// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3NGQY","content":"styles_content__2J3OE","navButtons":"styles_navButtons__2ytc4"};